import type { FC } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import type { RegionData } from "@/pages/CampaignOverviewPage/utils/geoDerivation";
import { TEXT } from "@/constants/text";
import { integerFormatter, fmtPct } from "@/utils/tableFormatters";
import styles from "@/pages/CampaignOverviewPage/widgets/GeoWidget.module.css";
import dataTableStyles from "@/components/DataTableCard/DataTableCard.module.css";

interface GeoGridProps {
  globalFilter: string;
  regionTotals: RegionData[];
  onExportCsv: () => void;
  onFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const GeoGrid: FC<GeoGridProps> = ({
  globalFilter,
  regionTotals,
  onExportCsv,
  onFilterChange,
}) => {
  const geoText = TEXT.campaignOverview.geo;

  return (
    <>
      <div className={styles.gridHeader}>
        <span className={styles.gridTitle}>{geoText.gridTitle}</span>
        <div className={styles.gridControls}>
          <input
            className={styles.filterInput}
            placeholder={geoText.filterPlaceholder}
            type="text"
            value={globalFilter}
            onChange={onFilterChange}
          />
          <button
            className={styles.exportBtn}
            disabled={regionTotals.length === 0}
            onClick={onExportCsv}
          >
            {geoText.csvButton}
          </button>
        </div>
      </div>
      <div className={styles.gridView}>
        <DataTable
          className={dataTableStyles.table}
          columnResizeMode="fit"
          emptyMessage={geoText.emptyMessage}
          globalFilter={globalFilter}
          globalFilterFields={["region_name"]}
          pt={{
            bodyRow: { className: dataTableStyles.tableRow },
            header: { className: dataTableStyles.columnHeader },
          }}
          resizableColumns
          scrollable
          scrollHeight="100%"
          tableStyle={{ tableLayout: "fixed" }}
          value={regionTotals}
        >
          <Column
            body={(region) => region.region_name}
            field="region_name"
            header="Region"
            sortable
          />
          <Column
            align="right"
            body={(region) => integerFormatter.format(region.impressions)}
            field="impressions"
            header="Impressions"
            headerStyle={{ textAlign: "right" }}
            sortable
          />
          <Column
            align="right"
            body={(region) => integerFormatter.format(region.clicks)}
            field="clicks"
            header="Clicks"
            headerStyle={{ textAlign: "right" }}
            sortable
          />
          <Column
            align="right"
            body={(region) => fmtPct(region.ctr)}
            field="ctr"
            header="CTR"
            headerStyle={{ textAlign: "right" }}
            sortable
          />
          <Column
            align="right"
            body={(region) => fmtPct(region.video_complete_rate)}
            field="video_complete_rate"
            header="VCR"
            headerStyle={{ textAlign: "right" }}
            sortable
          />
        </DataTable>
      </div>
    </>
  );
};

export default GeoGrid;
